import React from 'react';
import { COLORS } from '@constants';
import { StyledFlex, StyledLink } from './styled';

const Title = ({ dataE2e, text, onClick, isManual = true }) => {
    return (
        <StyledFlex data-e2e={`integrations-${dataE2e}-modal_title_text`} align='center' justify='space-between'>
            {text}
            {isManual ? (
                <StyledLink
                    data-e2e={`integrations-${dataE2e}-modal_api-guide_link`}
                    color={COLORS.$info}
                    onClick={onClick}
                >
                    API integration guide
                </StyledLink>
            ) : null}
        </StyledFlex>
    );
};

export default Title;
